export class RequestAddEvaluador {
    ID_evaluado: number;
    ID_evaluador: number;
    nombreEvaluador: string;
    relacionEvaluador: string;
    aprobacion: string;
    areaEvaluador: string;
}